import {LogInfo, LogLevel} from '@interopio/gateway-server/gateway-ent';
import * as IOGatewayLogging from '@interopio/gateway/logging/core';
import {format} from 'node:util';

class LogInfoAdapter implements LogInfo {
    readonly #event: IOGatewayLogging.LogEvent;
    #parsed?: { err?: Error, msg: string };
    #timestamp?: string;
    #output?: string;


    constructor(event: IOGatewayLogging.LogEvent) {
        this.#event = event;
    }

    private parsed(): { err?: Error, msg: string } {
        if (this.#parsed === undefined) {
            let err: Error | undefined = undefined;
            let vargs = this.#event.data;
            if (this.#event.data[0] instanceof Error) {
                err = this.#event.data[0];
                vargs = vargs.slice(1);
            }
            const msg = format(this.#event.message, ...vargs);
            this.#parsed = {err, msg};
        }
        return this.#parsed;
    }

    get time(): Date {
        return this.#event.time;
    }

    get level(): LogLevel {
        return this.#event.level;
    }

    get namespace() {
        return this.#event.name;
    }

    get file(): string {
        return undefined as unknown as string;
    }

    get line(): number {
        return undefined as unknown as number;
    }

    get message(): string {
        return this.parsed().msg;
    }

    get stacktrace(): Error | undefined {
        return this.parsed().err;
    }

    private get timestamp(): string {
        if (this.#timestamp === undefined) {
            this.#timestamp = this.time.toISOString();
        }
        return this.#timestamp;
    }

    get output(): string {
        if (this.#output === undefined) {
            const err = this.parsed().err;
            const stacktrace = err ? `\n${err.stack ?? err}` : '';
            this.#output = `${this.timestamp} ${this.level.toUpperCase()} [${this.namespace}] - ${this.message}${stacktrace}`;
        }
        return this.#output;
    }
}

export function toLogConfig(config?: { level?: LogLevel; appender?: (info: LogInfo) => void , disabled_action_groups?: string[]}): IOGatewayLogging.LogConfig {
    let level: Exclude<LogLevel, 'report' | 'fatal'> = 'info';
    if (config?.level) {
        if (config.level === 'fatal') {
            level = 'error';
        } else if (config.level !== 'report') {
            level = config.level;
        }
    }

    const result: IOGatewayLogging.LogConfig = { level: typeof level === 'string' ? { gateway: level } : level };
    if (config?.disabled_action_groups) {
        config.disabled_action_groups.forEach(actionGroup => {
            result.level[`gateway.action.${actionGroup}`] = 'off';
        })
    }
    const appenderFn = config?.appender;
    if (appenderFn) {
        result.appender = (event: IOGatewayLogging.LogEvent) => {
            appenderFn(new LogInfoAdapter(event));
        };
    }
    return result;
}
